import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
    import THGCO2EquivalentForm from '@/components/thg/co2_equivalents/THGCO2EquivalentForm.vue';
    import { useRouter } from 'vue-router/composables';
    import emitter from '@/utils/mitt';
    import { addTHGCO2Equivalent } from '@/api/thg/co2_equivalents';
    import { alertError } from '@/utils/dialogs';
    import { THGCO2Equivalent } from '@/interfaces/thg/THGCO2Equivalent';
    import { ToastProgrammatic as Toast } from 'buefy';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NewTHGCO2Equivalent',
  setup(__props) {

    const router = useRouter();
    const newEquivalent = ref<THGCO2Equivalent>({});

    async function addEquivalent() {
        emitter.emit('showLoader');

        // do the actual update
        const response = await addTHGCO2Equivalent(newEquivalent.value);

        if (response.status !== 200) {
            if (response.status === 409) {
                alertError(
                    'Fehler',
                    `Ein CO₂-Äquivalent für das Jahr <b>${newEquivalent.value.year}</b> existiert bereits.`,
                );
            } else {
                alertError('Fehler', 'Fehler beim Speichern des CO₂-Äquivalents.');
            }
        } else {
            Toast.open({ type: 'is-success', message: 'CO₂-Äquivalent erfolgreich angelegt.' });
            router.push({ name: 'thgco2equivalentslist' });
        }

        emitter.emit('hideLoader');
    }

return { __sfc: true,router, newEquivalent, addEquivalent, THGCO2EquivalentForm }
}

})